import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Typography, Link, Box, Chip } from "@mui/material";
import { Home as HomeIcon, NavigateNext as NavigateNextIcon } from '@mui/icons-material';

export const BreadcrumbContext = React.createContext();

export const Breadcrumb = ({ links }) => {
  if (!links || links.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{
        '& .MuiBreadcrumbs-separator': {
          mx: 0.5,
          color: 'text.secondary'
        }
      }}
    >
      {/* Always show home link first */}
      {!links.some(link => link.to === '/') && (
        <Link
          color="inherit"
          to="/"
          component={RouterLink}
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
            },
            fontSize: 14,
            fontWeight: 500
          }}
        >
          <HomeIcon sx={{ mr: 0.5, verticalAlign: 'middle', mt: '-4px' }} fontSize="small" />
          Home
        </Link>
      )}

      {links.map((link, key) =>
        link.to && !link.active ? (
          <Link
            key={key}
            to={link.to}
            component={RouterLink}
            sx={{
              textDecoration: 'none',
              color: 'text.secondary',
              '&:hover': {
                color: 'primary.main',
              },
              fontSize: 14,
              fontWeight: 500
            }}
          >
            {link.to === '/' && (
              <HomeIcon sx={{ mr: 0.5, verticalAlign: 'middle', mt: '-4px' }} fontSize="small" />
            )}
            {link.text}
          </Link>
        ) : (
          <Box key={key}>
            {link.active ? (
              <Chip
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {link.to === '/' && (
                      <HomeIcon sx={{ mr: 0.5, verticalAlign: 'middle', mt: '-4px' }} fontSize="small" />
                    )}
                    {link.text}
                  </Box>
                }
                size="small"
                color="primary"
                sx={{ 
                  fontSize: 14, 
                  fontWeight: 500,
                  height: 24
                }}
              />
            ) : (
              <Typography
                color="text.primary"
                sx={{
                  fontSize: 14,
                  fontWeight: 600
                }}
              >
                {link.text}
              </Typography>
            )}
          </Box>
        )
      )}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
